import $ from 'jquery';
import StringEncryptionService from './login/string-encryption-service';
import storageWrapper from './common/storage-wrapper';
import { initializeTheme, setupUiPanelToggle } from './layout/main-menu';
/*
    т.к. в браузерах есть авто-заполнение полей, которое не предоставляет событий на изменения,
    функция периодически проверяет состояние полей и скрывает соответствующие кнопки
*/
let ensureButtonsStateTimout = 0;
function ensureButtonsState() {
    window.clearTimeout(ensureButtonsStateTimout);
    const isUsernameEntered = $('#txtUsrName')?.val()?.length > 0;
    const isPasswordEntered = $('#txtPwd')?.val()?.length > 0;

    const btnDomainLogin = $('.btn-domain-login');
    const btnLogin = $('#btn-login');

    if (isUsernameEntered && isPasswordEntered) {
        btnLogin.removeAttr('disabled');
        btnDomainLogin.attr('disabled', 'disabled');
    }
    else if (!isUsernameEntered && !isPasswordEntered) {
        btnDomainLogin.removeAttr('disabled');
        btnLogin.attr('disabled', 'disabled');
    }
    else {
        btnLogin.attr('disabled', 'disabled');
        btnDomainLogin.attr('disabled', 'disabled');
    }
    ensureButtonsStateTimout = window.setTimeout(ensureButtonsState, 2000);
}

function hideErrors() {
    $('.input-wrap.error').removeClass('error');
    $('.domen-name-login').removeClass('error');
}

$(document).ready(function () {
    initializeTheme();
    //show help tip
    const $helpButton = $('.header-help');
    if ($helpButton.length) {
        $helpButton.mouseenter(function () {
            $('.help-tip').show();
        });
        $helpButton.mouseleave(function () {
            $('.help-tip').hide();
        });
    }
    //show login password
    if ($('.login-block').length) {
        const $showPasswordButton = $('.show-password');
        if(window.matchMedia("(hover: hover)").matches) {
            //show password for desktop
            $showPasswordButton.mousedown(function () {
                $(this).addClass('active');
                $(this).parent().find('input').prop("type", "text");
            });
            $showPasswordButton.mouseup(function () {
                $(this).removeClass('active');
                $(this).parent().find('input').prop("type", "password");
            });
        } else {
            //show password for touch
            $showPasswordButton.on('click', function () {
                if ($(this).hasClass('active')) {
                    $(this).removeClass('active');
                    $(this).parent().find('input').prop("type", "password");
                } else {
                    $(this).addClass('active');
                    $(this).parent().find('input').prop("type", "text");
                }
            });
        }

        const $clearNameButton = $('.clear-text-field');
        if(window.matchMedia("(hover: hover)").matches) {
            $clearNameButton.mousedown(function () {
                $(this).addClass('active');
                $clearNameButton.siblings('input:text').val('');
                hideErrors();
            });
            $clearNameButton.mouseup(function () {
                $(this).removeClass('active');
            });
        } else {
            $clearNameButton.on('click', function () {
                if ($(this).hasClass('active')) {
                    $(this).removeClass('active');
                } else {
                    $(this).addClass('active');
                    $clearNameButton.siblings('input:text').val('');
                    hideErrors();
                }
            });
        }
        const switcher = $('.header-menu-switcher-ui');
        switcher.toggleClass('hide', !storageWrapper.getShowSwitchUi());
    }

    //login form submit
    $('#login-form').submit(function () {
        hideErrors();

        const loginInput = $('input[name="UserName"]');
        const passwordInput = $('input[name="Password"]');
        const login = loginInput.val();
        const password = passwordInput.val();

        if (login && password) {
            const encryptionService = new StringEncryptionService();
            const encryptedPassword = encryptionService.encryptString(password);

            $('<input>').attr({
                type: 'hidden',
                name: 'Password',
                value: encryptedPassword
            }).appendTo('#login-form');

            passwordInput.prop('disabled', true);

            return true;
        }

        if (!login)
            loginInput.parent().addClass('non-text-error');

        if (!password)
            passwordInput.parent().addClass('non-text-error');

        return false;
    });

    $('.btn-domain-login').on('click', function () {
        if ($(this).is('[disabled]'))
            return;
        hideErrors();
        window.setTimeout(function () {
            $('#btn-domain-login').click();
        }, 0);
    });

    $('#txtUsrName,#txtPwd').on('keydown change focus blur click', function () {
        window.setTimeout(ensureButtonsState, 0);
    });

    // для случаев, когда браузеры заполняют поля автоматически
    window.setTimeout(ensureButtonsState, 100);
    window.setTimeout(function () {
        ensureButtonsState();
        window.setTimeout(function () {
            $('#txtUsrName').focus();
            ensureButtonsState();
        }, 1000);
    }, 500);
});

$(document).bind('touchstart', function (event) {
    const target = $(event.target);
    if (!target.is('.header-help')) {
        $('.help-tip').hide();
    } else {
        $('.help-tip').show();
    }
});

$(document).on('uiBodyFrameLoaded', () => {
    setupUiPanelToggle();
});
